// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';
export let DirectMarginMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_MARGIN_RESPONSE)

    this.BuyingPowerName = null;
    this.CommissionsByOperationMode = {};

    this.OperationMode = null;

    this.InitMarginBuy = null;
    this.MaintMarginBuy = null;
    this.WarnMarginBuy = null;

    this.InitMarginSell = null;
    this.MaintMarginSell = null;
    this.WarnMarginSell = null;

    this.AfterTradeFundsBuy = null;
    this.AfterTradeFundsSell = null;

    this.SwapBuy = null;
    this.SwapSell = null;
}

export let CommissionGroup = function ()
{
    this.CommissionType = null;
    this.OperationType = null;
    this.Amount = null;
    this.CurrencyId = null;
}

DirectMarginMessage.prototype = Object.create(DirectMessageBase.prototype)